import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faH2 } from '@fortawesome/pro-light-svg-icons';

export type ProLightH2Props = IconComponentProps;

export const ProLightH2 = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightH2Props) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faH2}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faH2}
    />
  );
};

ProLightH2.displayName = 'ProLightH2';
